import { useTranslation } from 'react-i18next';

// Shown when a write to the creator's own record fails. Before this the cabinet reverted the
// toggle or kept the editor open without a word, so a dropped connection looked like a bug.
export function SaveError({ text }: { text?: string }) {
  const { t } = useTranslation('provider');
  return (
    <span role="alert" style={{ display: 'block', color: 'var(--danger-text)', fontSize: 13, lineHeight: 1.4, marginTop: 8 }}>
      {text ?? t('creator.saveFailed', { defaultValue: 'Не сохранилось. Проверьте интернет и попробуйте ещё раз.' })}
    </span>
  );
}
